export default (state, action) => {
    switch (action.type) {
        case "CLEAR_DRUID":
            return {
                ...state,
                druid: ""
            };
        case "GENERATE_DRUID":
            const { druid } = action.payload;
            return {
                ...state,
                druid: druid
            };
        default:
            return state;
    }
}